var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAddressIcon = function SvgAddressIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10 13",
    width: 10,
    height: 13
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.002 13C4.705 13 0 9.232 0 5.129 0 2.296 2.24 0 5.002 0c2.762 0 5.001 2.296 5.001 5.129 0 4.103-4.705 7.87-5.001 7.87zM5 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"
  })));
};
export default SvgAddressIcon;